import type { Router } from "vue-router";

type ScheduleType = (task: () => void) => void;

function scheduleAfterFirstRender(task: () => void): void {
	requestAnimationFrame(() => setTimeout(task));
}

function loadPrefetchComponents(router: Router): void {
	for (const record of router.getRoutes()) {
		const component = record.components?.default;
		if (record.meta.prefetch !== true || typeof component !== "function") {
			continue;
		}
		Promise.resolve((component as () => unknown)()).catch(() => {});
	}
}

export function prefetchRouteComponents(router: Router, schedule: ScheduleType = scheduleAfterFirstRender): void {
	schedule(() => loadPrefetchComponents(router));
}
